// extracted by mini-css-extract-plugin
module.exports = {"icon":"imagebig_icon_ggmL0","rootinner":"imagebig_rootinner_3TOBy","bg":"imagebig_bg_5v34U","text":"imagebig_text_1MWDP","btn":"imagebig_btn_29mvO"};